<div class="single-size" *ngIf="sizePrices.length === 1">
  <div class='price fw-500' *ngIf="selectedSizePrice.isAvailable">
     <span *ngIf="sizePrices[0].label !== 'Size' && sizePrices[0].label !== sizePrices[0].size">{{sizePrices[0].label}} </span>
    {{selectedSizePrice.price | currency:'USD':'symbol'}}
    <ng-container *ngIf='selectedSizePrice.servings'>({{orderableItemService.getServings(selectedSizePrice)}})</ng-container>
  </div>
  <div *ngIf="selectedSizePrice.isFree" class="size-price-free-label">{{selectedSizePrice.statusLabel}}</div>
</div>
<div class="multiple-sizes" *ngIf="sizePrices.length > 1">

  <select name="size" [ngModel]="selectedSizePrice" (ngModelChange)="onSizePriceChanged($event)"
          class="form-control primary-bg-color primary-text-color fw-500 size item-size-options" [attr.aria-label]="'component.size_prices.size_options' | translate">
    <option *ngFor='let sizePrice of sizePrices'
            [ngValue]='sizePrice' [disabled]="sizePrice.isUnavailable">
      {{sizePrice.label}}
      <ng-container *ngIf='sizePrice.servings'>({{orderableItemService.getServings(sizePrice)}})</ng-container>
      {{
        sizePrice.isUnavailable ? '- ' + ('component.size_prices.size_options' | translate) :
        sizePrice.startingPrice ? ' from ' + (sizePrice.price | currency:'USD':'symbol') : '&nbsp;' + (sizePrice.price | currency:'USD':'symbol')
      }}
    </option>
  </select>
</div>
